import React, { useEffect } from 'react'
import { companyProfileInfoForUser } from '../../../../API/Settings/Company Settings/companySettingsAPI';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';
import { convertDateFormat } from '../../../../Js/Date';

const PosSummaryReportPrint = (props) => {
    const { formValues, grandTotals } = props
    const { tableLoading } = useSelector((state) => state.mainDashBoardSlice)

    const companyProfileData = useSelector(
        (state) => state?.companyProfileSlice?.userValue
    );
    const { reportsList } = useSelector((state) => state.posShiftSummaryReportSlice)
    const decimalPosition = localStorage.getItem("decimalPosition");



    return (
        <div className="print-main-div" style={{ backgroundColor: "white", fontFamily: "Arial, sans-serif", padding: "20px" }}>
            <div className='header-div' style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", borderBottom: "2px solid #333", paddingBottom: "15px" }}>
                <div style={{ flex: "1" }}>
                    {companyProfileData?.companyLogo && (
                        <img src={companyProfileData?.companyLogo} alt="" style={{ height: "60px", maxWidth: "150px" }} onError={(e) => { if (e?.target?.style) e.target.style.display = 'none'; }} />
                    )}
                </div>
                <div style={{ flex: "1", textAlign: "center" }}>
                    <h1 style={{ fontSize: "18px", margin: "0", fontWeight: "bold" }}>Shift Summary Report</h1>
                    <p style={{ margin: "5px 0 0 0", fontSize: "14px", color: "#666" }}>Sales Details</p>
                </div>
                <div style={{ flex: "1", textAlign: "right" }}>
                    <h2 style={{ fontSize: "14px", margin: "0", fontWeight: "bold" }}>{companyProfileData?.companyName || 'Company Name'}</h2>
                    <p style={{ margin: "2px 0", fontSize: "11px", color: "#666" }}>{companyProfileData?.companyAddress}</p>
                    <p style={{ margin: "2px 0", fontSize: "11px", color: "#666" }}>{companyProfileData?.companyContact}</p>
                </div>
            </div>
            <div className='global-white-bg-container shift-report-table-container' style={{ overflow: "visible" }}>

                {

                    tableLoading ?
                        <div className="new-global-table-container">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Order Date</th>
                                        <th>Order Ref</th>
                                        <th>Customer</th>
                                        <th>Mobile</th>
                                        <th>Order Amount</th>
                                        <th>Paid Amount</th>
                                        <th>Bank</th>
                                        <th>Cash</th>
                                        <th>Credit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        [...Array(10)].map((_, i) => (
                                            <tr key={i}>
                                                <td colspan={15}>
                                                    <Skeleton variant="rectangular"
                                                        animation="wave"
                                                        width={"100%"}
                                                        height={40} />
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                        :
                        reportsList?.length !== 0 ?
                            reportsList?.map((list, i) => (
                                <div key={i} className="avoid-break" style={{ pageBreakInside: "avoid", marginBottom: "25px" }}>
                                    <div className="single-view-left-ctn avoid-break" style={{ width: "100%", padding: "15px", marginBottom: "15px", backgroundColor: "#f8f9fa", border: "1px solid #dee2e6", borderRadius: "5px", pageBreakInside: "avoid" }}>
                                        <h3 style={{ margin: "0 0 10px 0", fontSize: "16px", fontWeight: "bold", color: "#333" }}>{formValues.branch?.branchName || "-NIL-"}</h3>
                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                                            <div style={{ display: "flex", gap: "15px" }}>
                                                <div>
                                                    <p style={{ margin: "0 0 3px 0", fontSize: "11px", fontWeight: "bold", color: "#666" }}>Shift</p>
                                                    <p style={{ margin: "0 0 3px 0", fontSize: "11px", fontWeight: "bold", color: "#666" }}>Employee</p>
                                                </div>
                                                <div>
                                                    <p style={{ margin: "0 0 3px 0", fontSize: "12px", fontWeight: "normal" }}>SHIFT {list?.shift?.shiftId}</p>
                                                    <p style={{ margin: "0 0 3px 0", fontSize: "12px", fontWeight: "normal" }}>{list?.shift?.empName}</p>
                                                </div>
                                            </div>
                                            <div style={{ display: "flex", gap: "15px" }}>
                                                <div>
                                                    <p style={{ margin: "0 0 3px 0", fontSize: "11px", fontWeight: "bold", color: "#666" }}>Start Date</p>
                                                    <p style={{ margin: "0 0 3px 0", fontSize: "11px", fontWeight: "bold", color: "#666" }}>End Date</p>
                                                </div>
                                                <div>
                                                    <p style={{ margin: "0 0 3px 0", fontSize: "12px", fontWeight: "normal" }}>{list?.shift?.startDate}</p>
                                                    <p style={{ margin: "0 0 3px 0", fontSize: "12px", fontWeight: "normal" }}>{list?.shift?.endDate}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="new-global-table-container" style={{ overflow: "visible", maxHeight: "fit-content", pageBreakInside: "avoid" }}>
                                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "11px", border: "1px solid #dee2e6" }}>
                                            <thead>
                                                <tr style={{ backgroundColor: "#f8f9fa", borderBottom: "2px solid #dee2e6" }}>
                                                    <th style={{ padding: "8px", textAlign: "left", fontWeight: "bold", border: "1px solid #dee2e6", backgroundColor: "#f8f9fa" }}>Order Date</th>
                                                    <th style={{ padding: "8px", textAlign: "left", fontWeight: "bold", border: "1px solid #dee2e6", backgroundColor: "#f8f9fa" }}>Order Ref</th>
                                                    <th style={{ padding: "8px", textAlign: "left", fontWeight: "bold", border: "1px solid #dee2e6", backgroundColor: "#f8f9fa" }}>Customer</th>
                                                    <th style={{ padding: "8px", textAlign: "left", fontWeight: "bold", border: "1px solid #dee2e6", backgroundColor: "#f8f9fa" }}>Mobile</th>
                                                    <th style={{ padding: "8px", textAlign: "right", fontWeight: "bold", border: "1px solid #dee2e6", backgroundColor: "#f8f9fa" }}>Order Amount</th>
                                                    <th style={{ padding: "8px", textAlign: "right", fontWeight: "bold", border: "1px solid #dee2e6", backgroundColor: "#f8f9fa" }}>Paid Amount</th>
                                                    <th style={{ padding: "8px", textAlign: "right", fontWeight: "bold", border: "1px solid #dee2e6", backgroundColor: "#f8f9fa" }}>Credit</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(list?.orders && list.orders.length > 0) ?
                                                    list.orders.map((item, i) => (
                                                        <tr key={i} style={{ backgroundColor: i % 2 === 0 ? "#ffffff" : "#f8f9fa" }}>
                                                            <td style={{ padding: "6px 8px", border: "1px solid #dee2e6", height: "28px" }}>{convertDateFormat(item?.orderDate)}</td>
                                                            <td style={{ padding: "6px 8px", border: "1px solid #dee2e6", height: "28px" }}>{item?.name}</td>
                                                            <td style={{ padding: "6px 8px", border: "1px solid #dee2e6", height: "28px" }}>{item?.customerName}</td>
                                                            <td style={{ padding: "6px 8px", border: "1px solid #dee2e6", height: "28px" }}>{item?.custMobile}</td>
                                                            <td style={{ padding: "6px 8px", border: "1px solid #dee2e6", height: "28px", textAlign: "right", fontFamily: "monospace" }}>{item?.amtTotal?.toFixed(decimalPosition)}</td>
                                                            <td style={{ padding: "6px 8px", border: "1px solid #dee2e6", height: "28px", textAlign: "right", fontFamily: "monospace" }}>{item?.paidAmt?.toFixed(decimalPosition)}</td>
                                                            <td style={{ padding: "6px 8px", border: "1px solid #dee2e6", height: "28px", textAlign: "right", fontFamily: "monospace" }}>{item?.amountDue?.toFixed(decimalPosition)}</td>
                                                        </tr>
                                                    ))
                                                    :
                                                    <tr>
                                                        <td colSpan="7" style={{ padding: "20px", textAlign: "center", border: "1px solid #dee2e6", fontStyle: "italic", color: "#666" }}>No Records Found</td>
                                                    </tr>
                                                }
                                            </tbody>
                                            <tfoot>
                                                <tr style={{ backgroundColor: "#e9ecef", fontWeight: "bold", borderTop: "2px solid #dee2e6" }}>
                                                    <td colSpan="4" style={{ padding: "8px", textAlign: "right", fontWeight: "bold", border: "1px solid #dee2e6", backgroundColor: "#e9ecef" }}>SHIFT TOTAL</td>
                                                    <td style={{ padding: "8px", textAlign: "right", fontWeight: "bold", border: "1px solid #dee2e6", backgroundColor: "#e9ecef", fontFamily: "monospace" }}>{list?.totalAmtTotal?.toFixed(decimalPosition)}</td>
                                                    <td style={{ padding: "8px", textAlign: "right", fontWeight: "bold", border: "1px solid #dee2e6", backgroundColor: "#e9ecef", fontFamily: "monospace" }}>{list?.totalPaidAmt?.toFixed(decimalPosition)}</td>
                                                    <td style={{ padding: "8px", textAlign: "right", fontWeight: "bold", border: "1px solid #dee2e6", backgroundColor: "#e9ecef", fontFamily: "monospace" }}>{list?.totalDueAmount?.toFixed(decimalPosition)}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            ))
                            :
                            <div className="center-div">
                                No Records
                            </div>
                }
                {/* Grand Total Section */}
            {Object.keys(grandTotals).length !== 0 && (
                <div className="grand-total avoid-break">
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                        <tbody>
                            <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", border: "2px solid #333" }}>
                                <td colSpan="4" style={{ padding: "12px", textAlign: "right", fontWeight: "bold", fontSize: "14px", border: "2px solid #333", backgroundColor: "#f8f9fa" }}>
                                    GRAND TOTAL
                                </td>
                                <td style={{ padding: "12px", textAlign: "right", fontWeight: "bold", fontSize: "14px", border: "2px solid #333", backgroundColor: "#f8f9fa", fontFamily: "monospace" }}>
                                    {Number(grandTotals?.totalAmtTotal)?.toFixed(decimalPosition)}
                                </td>
                                <td style={{ padding: "12px", textAlign: "right", fontWeight: "bold", fontSize: "14px", border: "2px solid #333", backgroundColor: "#f8f9fa", fontFamily: "monospace" }}>
                                    {Number(grandTotals?.totalPaidAmt)?.toFixed(decimalPosition)}
                                </td>
                                <td style={{ padding: "12px", textAlign: "right", fontWeight: "bold", fontSize: "14px", border: "2px solid #333", backgroundColor: "#f8f9fa", fontFamily: "monospace" }}>
                                    {Number(grandTotals?.totalDueAmount)?.toFixed(decimalPosition)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
            </div>

            <div>

            </div>

        </div>
    )
}

export default PosSummaryReportPrint